export default "__VITE_ASSET__DZ3DB8PD__"